import React from 'react';
import { X, AlertCircle, Loader } from 'lucide-react';

/**
 * Componente reutilizable para visualizar imágenes y videos
 * 
 * @param {Object} props
 * @param {Object} props.media - Objeto con id y url del medio
 * @param {number} props.index - Índice del elemento en la lista
 * @param {Object} props.mediaErrors - Objeto con errores de carga
 * @param {function} props.onDelete - Función para eliminar el medio
 * @param {function} props.handleMediaError - Función para manejar errores de carga
 * @param {function} props.setMediaErrors - Función para establecer errores de carga
 */
const MediaItem = ({ 
  media, 
  index, 
  mediaErrors, 
  onDelete, 
  handleMediaError, 
  setMediaErrors,
  forceVideo = false,
}) => {
  const { id, url } = media;
  const isVideo = url.includes('/api/media/video/') || url.toLowerCase().match(/\.(mp4|mov|mpeg|avi)$/i) || forceVideo;

  return (
    <div className="relative group rounded-lg overflow-hidden bg-black">
      {isVideo ? (
        <div className="aspect-video w-full">
          {mediaErrors[url] && mediaErrors[url] !== 'loading' ? (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
              <div className="text-center p-4">
                <AlertCircle className="w-10 h-10 text-red-500 mx-auto mb-2" />
                <p className="text-sm text-gray-600">Error al cargar el video</p>
              </div>
            </div>
          ) : (
            <div className="relative w-full h-full">
              <video 
                controls 
                preload="metadata"
                playsInline
                className="w-full h-full object-contain"
                onError={(e) => handleMediaError(url, e)}
                onLoadStart={() => setMediaErrors(prev => ({ ...prev, [url]: 'loading' }))}
                onLoadedData={() => setMediaErrors(prev => ({ ...prev, [url]: null }))}
              >
                <source 
                  src={url} 
                  type="video/mp4"
                />
                Tu navegador no soporta videos.
              </video>
              {mediaErrors[url] === 'loading' && (
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
                  <Loader className="w-8 h-8 text-white animate-spin" />
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <img 
          src={url}
          alt={`Ad Preview ${index}`}
          className="w-full aspect-video object-cover"
          onError={(e) => handleMediaError(url, e)}
        />
      )}
      {onDelete && (
        <div className="absolute top-3 right-3 bg-red-500 text-white rounded-full p-1.5 shadow-lg hover:bg-red-600 transition-colors">
          <X 
            className="w-5 h-5 cursor-pointer" 
            onClick={() => onDelete(id)} 
          />
        </div>
      )}
    </div>
  );
};

export default MediaItem; 